import { createContext, useContext } from 'react';

interface HeadContextInterface {
  setHelmetTitle: (title: string) => void;
  setHelmetMetaDescription: (desc: string) => void;
}

const initialContext: HeadContextInterface = {
  setHelmetTitle: () => null,
  setHelmetMetaDescription: () => null,
};

export const HeadContext = createContext<HeadContextInterface>(initialContext);
export const useHead = () => useContext(HeadContext);
